window._ = require( 'lodash' );
import Popper from 'popper.js/dist/umd/popper.js';

window.$ = window.jQuery = require( 'jquery' );
window.Tether = require( 'tether' );
window.Popper = Popper;
require( 'bootstrap' );

window.axios = require('axios');
window.axios.defaults.headers.common[ 'X-Requested-With' ] = 'XMLHttpRequest';
let token = document.head.querySelector( 'meta[name="csrf-token"]' );

if ( token ) {
	window.axios.defaults.headers.common[ 'X-CSRF-TOKEN' ] = token.content;
}
else {
	console.error( 'CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token' );
}

window.tinymce = require('tinymce');

import DatePicker from 'tui-date-picker';
window.DatePicker = DatePicker;

//Feather Icons
window.feather = require('feather-icons');
feather.replace();

import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
dayjs.extend(duration);

import 'dayjs/locale/ko';
dayjs.locale('ko');

window.dayjs = dayjs;

